import { render, staticRenderFns } from "./InfoOwnerDrawer.vue?vue&type=template&id=766968b3"
import script from "./InfoOwnerDrawer.vue?vue&type=script&lang=js"
export * from "./InfoOwnerDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports